import { toggleTargetAttribute } from '@helpers/helpers.js';

const backupThemes = [
  {
    name: 'Home',
    class: 'nws',
    classHome: 'homepage',
    homeLink: `${SITEBASEURL}`,
    ticketsLink: `${SITEBASEURL}p/34`,
  },
  {
    name: 'Northern Wisconsin State Fair',
    class: 'nws-fair',
    classHome: 'nws-fair-home',
    idContainer: 'stateFairWidgets',
    homeLink: `${SITEBASEURL}p/experience-the-fair`,
    ticketsLink: `${SITEBASEURL}p/34`,
  },
  {
    name: 'BBQ Fest',
    class: 'nws-bbq',
    classHome: 'nws-bbq-home',
    idContainer: 'bbqFestWidgets',
    homeLink: `${SITEBASEURL}p/bbq-fest`,
    ticketsLink: `${SITEBASEURL}p/34`,
  },
  {
    name: 'Oktoberfest',
    class: 'nws-oktoberfest',
    classHome: 'nws-oktoberfest-home',
    idContainer: 'oktoberfestWidgets',
    homeLink: `${SITEBASEURL}p/oktoberfest`,
    ticketsLink: `${SITEBASEURL}p/34`,
  },
];

const body = $('body');

let themes = backupThemes;

export function setThemes(themesData) {
  themes = themesData || backupThemes;
}

export function getThemes() {
  return themes;
}

export function getThemeName() {
  const theme = themes.find((theme) => body.hasClass(theme.class));
  return theme ? theme.name : themes[0].name;
}

export function getThemeClass() {
  const theme = themes.find((theme) => body.hasClass(theme.class));
  return theme ? theme.class : themes[0].class;
}

export function isHomeTheme() {
  const theme = themes.find((theme) => body.hasClass(theme.classHome));
  return theme;
}

function emptyAfterContent() {
  const isSubpageHome = isHomeTheme();
  const isThemeHome = body.hasClass('homepage');
  const afterContent = $('.afterContent');
  if (!isSubpageHome || isThemeHome) {
    afterContent.children().remove();
  }
}

function toggleActiveSubpageHeaderLink() {
  const headerLinks = $('.themes-header li a');
  const themeName = getThemeName();

  function setHeaderLinks(link, linkText) {
    const theme = themes.find((theme) => theme.name.toLowerCase() === linkText.toLowerCase());
    const linkValid = theme.homeLink || theme.homeLink.length > 1;
    if (theme) {
      linkValid ? $(link).attr('href', theme.homeLink) : $(link).addClass('disabled');
    }
  }

  headerLinks.each((index, link) => {
    const linkText = $(link).text().trim();
    // set links
    setHeaderLinks(link, linkText);
    // compare themeName with the linkText
    if (linkText.toLowerCase().includes(themeName.toLowerCase())) {
      $(link).parent().remove();
      $(link).attr('target', '_blank');
    }
  });
}

function setTicketsURL() {
  const ticketBtn = $('.ticket-btn');
  const currentTheme = getThemeClass();
  const ticketLink = themes.find((theme) => theme.class === currentTheme).ticketsLink;
  ticketBtn.attr('href', ticketLink);
  toggleTargetAttribute(ticketBtn);
}

export function initThemeControllers() {
  toggleActiveSubpageHeaderLink();
  setTicketsURL();
  emptyAfterContent();
}
